import { restApiIP } from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApiIP.get("/api/classification/results", { params });
};

const getAllForCSV = params => {
  return restApiIP.get("/api/classification/results/csv", { params });
};

const remove = ids => {
  return restApiIP.delete(`/api/classification/results${ids}`);
};

const classificationResultService = {
  getAll,
  getAllForCSV,
  remove
};

export default classificationResultService;